var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"black--text text-no-wrap"},[_vm._v(" "+_vm._s(_vm.label)+" : ")]),_c('span',{staticClass:"text--secondary"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }